// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._5mHl2{overflow:hidden;padding:0 var(--mobile-row-gap) 8px;margin:0 calc(var(--mobile-row-gap)*-1)}@media screen and (min-width:768px){._5mHl2{padding:0;margin:0}}._5mHl2.ZXZfS{overflow-x:auto}@media screen and (min-width:768px){._5mHl2.ZXZfS{overflow-x:visible}}._5G8Vm{display:flex;flex-flow:wrap;padding:0;margin:-4px;list-style:none}@media screen and (min-width:768px){._5G8Vm{flex-flow:wrap}}.ZXZfS ._5G8Vm{flex-wrap:nowrap}.CFVNv{flex:0 0 auto;margin:4px}.CFVNv:last-child{padding-right:var(--mobile-row-gap)}@media screen and (min-width:768px){.CFVNv:last-child{padding-right:0}}.hH1lA:before{margin:0 4px;content:\"·\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": "_5mHl2",
	"isScrollable": "ZXZfS",
	"list": "_5G8Vm",
	"item": "CFVNv",
	"postfix": "hH1lA"
};
module.exports = ___CSS_LOADER_EXPORT___;
